import React from 'react';
import SuggestionCard from './SuggestionCard';
import { Music2 } from 'lucide-react';

const SuggestionList = ({ suggestions, loading }) => {
  if (loading) {
    return (
      <div className="text-center py-8">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-4 border-orange-500 border-t-transparent"></div>
        <p className="text-slate-400 mt-3">Chargement...</p>
      </div>
    );
  }

  if (suggestions.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="inline-block p-4 bg-slate-700/30 rounded-full mb-4">
          <Music2 className="w-8 h-8 text-slate-500" />
        </div>
        <p className="text-slate-400 text-lg mb-2">Aucune suggestion pour le moment</p>
        <p className="text-slate-500 text-sm">Cliquez sur "Suggérer une piste" pour commencer !</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {suggestions.map((suggestion) => (
        <SuggestionCard key={suggestion.id} suggestion={suggestion} />
      ))}
    </div>
  );
};

export default SuggestionList;
